<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加SIM卡信息"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="simInfo" :rules="rules">
      <FormItem prop="simNum">
        <Input v-model="simInfo.simNum" placeholder="请输入SIM卡号码">
        </Input>
      </FormItem>
      <FormItem prop="simShortNum">
        <Input v-model="simInfo.simShortNum" placeholder="请输入SIM卡11位号码">
        </Input>
      </FormItem>
      <FormItem prop="iccid">
        <Input v-model="simInfo.iccid" placeholder="请输入ICCID">
        </Input>
      </FormItem>
      <FormItem prop="operation">
        <Select placeholder="选择电信运营商"
                v-model="simInfo.operation"
        >
          <Option v-for="(option, index) in simOperationOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark">
        <Input type="textarea" v-model="simInfo.remark" placeholder="备注">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'AddSimInfoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    simNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: 'SIM卡号码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      simStateOptions: [
        { label: '未安装', value: 0 },
        { label: '已安装', value: 1 },
        { label: '停用', value: 2 }
      ],
      simOperationOptions: [
        { label: '中国移动', value: 1 },
        { label: '中国联通', value: 2 },
        { label: '中国电信', value: 3 },
        { label: '珠海移动专网', value: 4 },
        { label: '中国移动-东莞中智', value: 5 },
        { label: '中国移动-佛山交协', value: 6 },
        { label: '中国电信-中山邦悦', value: 7 },
        { label: '中国移动-河北九宸', value: 8 },
        { label: '中国移动-中山邦悦', value: 9 },
        { label: '中国联通-中山邦悦', value: 10 },
        { label: '中国移动-深圳晓聪', value: 11 }
      ],

      simInfo: {
        simNum: null,
        simShortNum: null,
        iccid: null,
        operation: null,
        remark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'SimInfoServ_AddObj'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '添加SIM卡信息',
        content: '<p>是否确认添加SIM卡信息</p>',
        onOk: () => {
          store.dispatch('SimInfoServ_AddObj', { params: this.simInfo }).then(() => {
            this.$Message.success('添加SIM卡信息成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.simInfo.simNum = null
        this.simInfo.simShortNum = null
        this.simInfo.iccid = null
        this.simInfo.operation = null
        this.simInfo.remark = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        simNum: this.simNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
